import React, { useRef } from 'react';
import { Box, Grid, Button } from '@material-ui/core';
import {Backdrop} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
///import { fade, makeStyles } from '@material-ui/core/styles';
// import TextField from '@mui/material/TextField';
// import TextareaAutosize from '@mui/base/TextareaAutosize';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import { MetaTags } from 'react-meta-tags';
import axios from 'axios';
///import LinearProgress from '@mui/material/LinearProgress';
import { MathJaxContext } from "better-react-mathjax";
import Header from "./HeaderMy";
import TimerHidden from '../components/TimerHidden';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import '../styles/bizofficer.css';
import Timer from '../components/Timer'; 
import DialogTestIns from '../components/DialogTestIns'; 
import DialogRegOne from '../components/DialogRegOne'; 
import DialogRegTwo from '../components/DialogRegTwo';
import DialogRegSelectCourse from '../components/DialogRegSelectCourse';
import DialogRegAlert from '../components/DialogRegAlert';
import DialogHelp from '../components/DialogHelp';
import AlertNoInternet from '../components/AlertNoInternet';
import { API_URL } from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

///sectionLock = No_Lock,Partially_Lock,Complete_Lock

// const useStyles = makeStyles((theme) => ({
// 	sectionDesktop: {
// 		display: 'none',
// 		[theme.breakpoints.up('md')]: {
// 		  display: 'inline-block',
// 		},
// 	  },
// 	  sectionMobile: {
// 		display: 'inline-block',
// 		[theme.breakpoints.up('md')]: {
// 		  display: 'none',
// 		},
// 	  },
//   }));
  

const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
};

export default function Execute() {
	const resetTimerRef = useRef();
	const openHelpRef = React.useRef();
	const internetRef = React.useRef(); 
	const regOneRef = React.useRef();
	const regTwoRef = React.useRef();
	const selectCourseRef = React.useRef();
	const regAlertRef = React.useRef();
	//const classes = useStyles();
	const [courseId, setCourseId] = React.useState(0);
	const [templateId, setTemplateId] = React.useState(0);

	const [pageLoading, setPageLoading] = React.useState(true);	
	const [testSet, setTestSet] = React.useState([]);
	const [clock, setClock] = React.useState("");
	const [currentQuestionObj, setCurrentQuestionObj] = React.useState({});
	const [currentQuestion, setCurrentQuestion] = React.useState(0);
	const [agreeToJumpQuestion, setAgreeToJumpQuestion] = React.useState(0);
	const [currentSection, setCurrentSection] = React.useState(1);
	const [answeredCurrentSectionArr, setAnsweredCurrentSectionArr] = React.useState([]);
	const [answeredArr, setAnsweredArr] = React.useState([]);
	const [totalQuestion, setTotalQuestion] = React.useState(0);
	const [notVisitedTotal, setNotVisitedTotal] = React.useState(totalQuestion);
	const [notAnsweredTotal, setNotAnsweredTotal] = React.useState(0);
	const [answeredTotal, setAnsweredTotal] = React.useState(0);
	const [reviewTotal, setReviewTotal] = React.useState(0);
	const [answeredReviewTotal, setAnsweredReviewTotal] = React.useState(0);
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [textMessage, setTextMessage] = React.useState("");
	const [sectionDialogShow, setSectionDialogShow] = React.useState(false);
	const [seconds, setSeconds] = React.useState(0);
	const [examType, setExamType] = React.useState("objective");
	const alphaArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

	const [helpCountQuestions, setHelpCountQuestions] = React.useState([]);

	const authResult = new URLSearchParams(window.location.search);
	const courseUrl = authResult.get('courseUrl');
	const corsId = authResult.get('courseId');
	const utmSource = authResult.get('utm_source');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	const testUid = authResult.get('testUid');	
	const testType = authResult.get('testType');

	// const questionType = authResult.get('questionType');
	// const totalTestQuestions = authResult.get('totalQuestion');
	// const totalTime = authResult.get('totalTime');
	// const marksCorrectAnswer = authResult.get('marksCorrectAnswer');
	// const marksIncorrectAnswer = authResult.get('marksIncorrectAnswer');
	// const marksNotAttempted = authResult.get('marksNotAttempted');
	const searchFlag = authResult.get('searchFlag');
	const searchQuery = authResult.get('searchQuery');
	const topicId = authResult.get('topicId');
	//const exammTyp = authResult.get('examType');
	const assessmentMode = authResult.get('assessmentMode');

	///console.log("testId >>> " + testId);
	var counterMRMT = 0, counterMCMT = 0;
	var vertical = 'top', horizontal = 'center';
	///element.classList.contains(className); 


	function maxQuestionAttemptCheck() {
		let retrn = false;
		let questionId = testSet[0].questionSet[currentQuestion].questionId;
		if (!testSet[0].questionSet[currentQuestion].sectionId && testSet[0].noQuestionAttempt>0 && questionId && document.getElementById('btn' + questionId).style.background.indexOf('/answered.png') > -1 && answeredArr.indexOf(questionId)===-1 && answeredArr.length>=testSet[0].noQuestionAttempt) {
			setShowAlert(true);
			setAlertMessage('You are not allowed to attempt more than ' + testSet[0].noQuestionAttempt + ' questions');
			retrn = true;
		}else if (testSet[0].questionSet[currentQuestion].sectionId>0 && testSet[0].questionSet[currentQuestion].noQuestionAttempt>0 && questionId && document.getElementById('btn' + questionId).style.background.indexOf('/answered.png') > -1 && answeredCurrentSectionArr.indexOf(questionId)===-1 && answeredCurrentSectionArr.length>=testSet[0].questionSet[currentQuestion].noQuestionAttempt) {
			setShowAlert(true);
			setAlertMessage('You are not allowed to attempt more than ' + testSet[0].questionSet[currentQuestion].noQuestionAttempt + ' questions in this section');
			retrn = true;
		}
		return retrn;
	}

	function checkedAnswers(num) {
		let questionId = testSet[0].questionSet[num].questionId;
		let checkedAns = [];
		if (testSet[0].questionSet[num].questionType && testSet[0].questionSet[num].questionType.indexOf("Subjective") > -1) {
			let subjectiveAns = '';
			if (document.getElementById("ans" + questionId + "a1").value && document.getElementById("ans" + questionId + "a1").value.length > 0) {
				subjectiveAns += document.getElementById("ans" + questionId + "a1").value + '$$$$$';
			} else {
				subjectiveAns += '$$$$$';
			}
			if (document.getElementById("ans" + questionId + "a2").value && document.getElementById("ans" + questionId + "a2").value.length > 0) {
				subjectiveAns += document.getElementById("ans" + questionId + "a2").value + '$$$$$' + document.getElementById("iframe" + questionId).src;
			}
			if (subjectiveAns.length > 5) {
				checkedAns.push(subjectiveAns);
			}
		} else if (testSet[0].questionSet[num].questionType == "Fill-In-Blank" || testSet[0].questionSet[num].questionType == "Fill-in-Blank") {
			if (document.getElementById("ans" + questionId + "a").value && document.getElementById("ans" + questionId + "a").value.length > 0) {
				checkedAns.push(document.getElementById("ans" + questionId + "a").value);
			}
		} else if (testSet[0].questionSet[num].questionType == "MR-Matching-Type" || testSet[0].questionSet[num].questionType == "Matching-Type") {
			let totalOptions = Object.keys(testSet[0].questionSet[num].columns[0].columnRows).length;
			totalOptions = totalOptions * totalOptions;
			for (let i = 1; i <= totalOptions; i++) {
				if (document.getElementById("ans" + questionId + "a" + i) && document.getElementById("ans" + questionId + "a" + i).checked == true) {
					checkedAns.push(document.getElementById("ans" + questionId + "a" + i).value)
				}
			}

		} else {
			let totalOptions = Object.keys(testSet[0].questionSet[num].responseChoice).length;
			for (let i = 0; i < totalOptions; i++) {
				if (document.getElementById("ans" + questionId + "a" + i) && document.getElementById("ans" + questionId + "a" + i).checked == true) {
					checkedAns.push(document.getElementById("ans" + questionId + "a" + i).value)
				}
			}

		}
		return checkedAns;
	}

	function mrResponse(num) {
		let questionId = testSet[0].questionSet[num].questionId;
		let checkedAns = [];
		checkedAns = checkedAnswers(num);
		if (checkedAns.length) {
			testSet[0].questionSet[num].studentResponse = checkedAns.join("~");
			testSet[0].questionSet[num].cssName = "qbg-visited";
			document.getElementById('ans' + questionId).innerHTML = checkedAns.join("~");
			document.getElementById('btn' + questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.add("qbg-visited");
			if (document.getElementById('btn' + questionId).style.background.indexOf('answered-review.png') > -1) {
			} else if (document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
				document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/answered-review.png')";
				testSet[0].questionSet[num].backgroundImg = "url('" + process.env.PUBLIC_URL + "/answered-review.png')";
			} else {
				document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/answered.png')";
				testSet[0].questionSet[num].backgroundImg = "url('" + process.env.PUBLIC_URL + "/answered.png')";
			}
		} else {
			testSet[0].questionSet[num].studentResponse = "";
			document.getElementById('ans' + questionId).innerHTML = "";
			testSet[0].questionSet[num].cssName = "qbg-visited";
			document.getElementById('btn' + questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.add("qbg-visited");
			if (document.getElementById('btn' + questionId).style.background.indexOf('answered-review.png') > -1) {
				document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/review.png')";
			} else if (document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
			} else {
				document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/not-answered.png')";
				testSet[0].questionSet[num].backgroundImg = "url('" + process.env.PUBLIC_URL + "/not-answered.png')";
			}
		}
	}
	function resetHandle() {

		let questionId = testSet[0].questionSet[currentQuestion].questionId;
		if (testSet[0].questionSet[currentQuestion].questionType == "Fill-In-Blank") {
			if (document.getElementById("ans" + questionId + "a").value && document.getElementById("ans" + questionId + "a").value.length > 0) {
				document.getElementById("ans" + questionId + "a").value = "";
			}
		} else if (testSet[0].questionSet[currentQuestion].questionType == "MR-Matching-Type" || testSet[0].questionSet[currentQuestion].questionType == "Matching-Type") {
			let totalOptions = Object.keys(testSet[0].questionSet[currentQuestion].columns[0].columnRows).length;
			totalOptions = totalOptions * totalOptions;
			for (let i = 1; i <= totalOptions; i++) {
				if (document.getElementById("ans" + questionId + "a" + i) && document.getElementById("ans" + questionId + "a" + i).checked == true) {
					document.getElementById("ans" + questionId + "a" + i).checked = false;
				}
			}

		} else {
			let totalOptions = Object.keys(testSet[0].questionSet[currentQuestion].responseChoice).length;
			for (let i = 0; i < totalOptions; i++) {
				if (document.getElementById("ans" + questionId + "a" + i) && document.getElementById("ans" + questionId + "a" + i).checked == true) {
					document.getElementById("ans" + questionId + "a" + i).checked = false;
				}
			}

		}

		if (document.getElementById('btn' + questionId).style.background.indexOf('answered-review.png') > -1) {
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/review.png')";
		} else if (document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
		} else {
			testSet[0].questionSet[currentQuestion].cssName = "qbg-not-visited";
			testSet[0].questionSet[currentQuestion].backgroundImg = "url('" + process.env.PUBLIC_URL + "/not-visited.png')";
			document.getElementById('btn' + questionId).classList.add("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.remove("qbg-visited");
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/not-visited.png')";
		}
		document.getElementById('ans' + questionId).innerHTML = "";
		testSet[0].questionSet[currentQuestion].studentResponse = "";
	}
	function uncheckHandle(chkId) {
		if (document.getElementById("hidetxt" + chkId).value == 1) {
			document.getElementById(chkId).checked = false;
			document.getElementById("hidetxt" + chkId).value = "";
		} else if (document.getElementById(chkId).checked == true) {
			let totalOptions = Object.keys(testSet[0].questionSet[currentQuestion].responseChoice).length;
			let questionId = testSet[0].questionSet[currentQuestion].questionId;
			for (let i = 0; i < totalOptions; i++) {
				document.getElementById("hidetxtans" + questionId + "a" + i).value = "";
			}
			document.getElementById("hidetxt" + chkId).value = 1;
		}
		mrResponse(currentQuestion);
	}
	function markReview() {
		let questionId = testSet[0].questionSet[currentQuestion].questionId;
		let checkedAns = [];
		checkedAns = checkedAnswers(currentQuestion);
		if (checkedAns.length) {
			document.getElementById('btn' + questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.add("qbg-visited");
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/answered-review.png')";
			testSet[0].questionSet[currentQuestion].cssName = "qbg-visited";
			testSet[0].questionSet[currentQuestion].backgroundImg = "url('" + process.env.PUBLIC_URL + "/answered-review.png')";
		} else {
			document.getElementById('btn' + questionId).classList.remove("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.add("qbg-visited");
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/review.png')";
			testSet[0].questionSet[currentQuestion].cssName = "qbg-visited";
			testSet[0].questionSet[currentQuestion].backgroundImg = "url('" + process.env.PUBLIC_URL + "/review.png')";
		}
		checkCurrentQuestion(currentQuestion);
	}
	function unmarkReview() {
		let questionId = testSet[0].questionSet[currentQuestion].questionId;
		if (document.getElementById('btn' + questionId).style.background.indexOf('answered-review.png') > -1) {
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/answered.png')";
			testSet[0].questionSet[currentQuestion].backgroundImg = "url('" + process.env.PUBLIC_URL + "/answered.png')";
		} else if (document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
			document.getElementById('btn' + questionId).classList.add("qbg-not-visited");
			document.getElementById('btn' + questionId).classList.remove("qbg-visited");
			document.getElementById('btn' + questionId).style.background = "url('" + process.env.PUBLIC_URL + "/not-visited.png')";
			testSet[0].questionSet[currentQuestion].cssName = "qbg-not-visited";
			testSet[0].questionSet[currentQuestion].backgroundImg = "url('" + process.env.PUBLIC_URL + "/not-visited.png')";
		}
		checkCurrentQuestion(currentQuestion);
	}
	function backHandle() {
		if(maxQuestionAttemptCheck()){
			resetHandle();
		}
		currentQuestion == 0 ? jumpToQuestion(0) : jumpToQuestion(currentQuestion - 1);
		if (currentQuestion == 0) {
			setShowAlert(true);
			setAlertMessage("You are at first question, Click on Next button.");
			return false;
		}
	}
	function nextHandle() {
		if(maxQuestionAttemptCheck()){
			resetHandle();
		}
		currentQuestion == (totalQuestion - 1) ? jumpToQuestion(currentQuestion) : jumpToQuestion(currentQuestion + 1);
		if (totalQuestion == (currentQuestion + 1)) {
			mrResponse(currentQuestion);
			setShowAlert(true);
			setAlertMessage("You are at last question, Click on 'Submit Test Now' button to submit your test OR Back button to review questions.");
			return false;
		}
	}
	function changeTimeInClock(num) {
		setTimeout(function () { //Start the timer
			setClock(testSet[0].questionSet[num].sectionTime);
			resetTimerRef.current.resetTimer(1); //After 1 second, set render to true
		}.bind(this), 1000)
	}
	function changeCurrentQuestion(num) {
		// UPDATE SPENT TIME ON A QUESTION
		testSet[0].questionSet[currentQuestion].timeSpent = parseInt(testSet[0].questionSet[currentQuestion].timeSpent) + seconds + 5;
		document.getElementById('questionBox' + currentQuestion).style.display = "none";
		document.getElementById('questionBox' + num).style.display = "";
		mrResponse(currentQuestion);
		setCurrentSection(testSet[0].questionSet[num].sectionOrder);
		setCurrentQuestion(num);
		testSet[0].lastQuestionIndex = num;
		setCurrentQuestionObj(testSet[0].questionSet[num]);
		setSeconds(0); //RESET TIME FOR CURRENT QUESTION
	}
	function jumpToQuestion(num) {
		if (num !== currentQuestion) {
			if (checkSection(num)) {
				changeCurrentQuestion(num);
				checkCurrentQuestion(num);
			}
		}
	}
	function checkSection(num) {
		let sectionLock = testSet[0].sectionLock;
		if (sectionLock == "Complete_Lock") {
			let jumpToSection = testSet[0].questionSet[num].sectionOrder;
			if (jumpToSection != currentSection) {
				setShowAlert(true);
				setAlertMessage("You are not allowed to move another section.");
				return false;
			}
		} else if (sectionLock == "Partially_Lock") {
			let jumpToSection = testSet[0].questionSet[num].sectionOrder;
			if (jumpToSection > currentSection) {
				setAgreeToJumpQuestion(num);
				setSectionDialogShow(true);
				return false;
			} else if (jumpToSection < currentSection) {
				setShowAlert(true);
				setAlertMessage("You are not allowed to move previous section.");
				return false;
			}
			// else{
			// 	///changeTimeInClock(num);
			// }
		}
		return true;
	}

	function timeFinished() {
		if (testSet && testSet[0] && testSet[0].sectionLock) {
			let sectionLock = testSet[0].sectionLock;
			if (testSet[0].sectionSet && testSet[0].sectionSet[currentSection] && (sectionLock == "Complete_Lock" || sectionLock == "Partially_Lock")) {
				let num = testSet[0].sectionSet[currentSection].questionNumbers[0].questionIndex;
				changeCurrentQuestion(num);
				changeTimeInClock(num);
			} else {
				///We have to move another page after submitted test			
				///alert("Your test time has been finished.\nyour test has been submitted automatically.");
				if (window.navigator.onLine) {
					submitTest();
				} else {
					//show alert of internet connection
					internetRef.current.handleClickOpen();
				}

			}
		}
	}

	function agreeToJumpSection() {
		sectionDialogHide();
		changeCurrentQuestion(agreeToJumpQuestion);
		changeTimeInClock(agreeToJumpQuestion);
	}

	function checkCurrentQuestion(num) {
		let questionId = testSet[0].questionSet[num].questionId;
		let sectionId = testSet[0].questionSet[num].sectionId;
		if (document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
			document.getElementById("markforreviewButtonId").style.display = "none";
			document.getElementById("unmarkforreviewButtonId").style.display = "";
		} else {
			document.getElementById("markforreviewButtonId").style.display = "";
			document.getElementById("unmarkforreviewButtonId").style.display = "none";
		}

		let currentNotVisitedTotal = 0;
		let currentAnsweredReviewTotal = 0;
		let currentReviewTotal = 0;
		let currentNotAnsweredTotal = 0;
		let currentAnsweredTotal = 0;
		let ansTotCurrentSectionArr = [];
		let ansArr = [];		
		for (let i = 0; i < totalQuestion; i++) {
			let questionId = testSet[0].questionSet[i].questionId;
			if (questionId && document.getElementById('btn' + questionId).style.background.indexOf('answered-review.png') > -1) {
				currentAnsweredReviewTotal++;
			} else if (questionId && document.getElementById('btn' + questionId).style.background.indexOf('review.png') > -1) {
				currentReviewTotal++;
			} else if (questionId && document.getElementById('btn' + questionId).style.background.indexOf('not-answered.png') > -1) {
				currentNotAnsweredTotal++;
			} else if (questionId && document.getElementById('btn' + questionId).style.background.indexOf('answered.png') > -1) {
				currentAnsweredTotal++;
				ansArr.push(questionId);
				if(sectionId===testSet[0].questionSet[i].sectionId){
					ansTotCurrentSectionArr.push(questionId);
				}
			} else {
				currentNotVisitedTotal++;
			}
		}
		setNotVisitedTotal(currentNotVisitedTotal);
		setAnsweredTotal(currentAnsweredTotal);
		setNotAnsweredTotal(currentNotAnsweredTotal);
		setReviewTotal(currentReviewTotal);
		setAnsweredReviewTotal(currentAnsweredReviewTotal);
		setAnsweredCurrentSectionArr(ansTotCurrentSectionArr);
		setAnsweredArr(ansArr);
	}

	function submitTestWithCourse(cid,tid,loginId,token){
		///alert('submit clicked: '+cid+" <===> "+tid);
		if(loginId && token){
			setCourseId(cid);
			setTemplateId(tid);
			submitTest(loginId,token,cid,tid);
		}

	}

	function submitTest(loginId,token,cid,tid) {
		////alert('Submit My Test Now');
		mrResponse(currentQuestion);
		let totalTestQuestions = 0;
		let ansQuestionSet = [];
		if (testSet && testSet[0].questionSet) {
			totalTestQuestions = testSet[0].questionSet.length;
			for (let i = 0; i < totalTestQuestions; i++) {
				let item = { "questionId": testSet[0].questionSet[i].questionId, "itemId": testSet[0].questionSet[i].itemId, "sectionId": testSet[0].questionSet[i].sectionId, "sectionName": testSet[0].questionSet[i].sectionName, "topicId": testSet[0].questionSet[i].topicId, "timeSpent": testSet[0].questionSet[i].timeSpent, "correctResponse": testSet[0].questionSet[i].correctResponse, "studentResponse": testSet[0].questionSet[i].studentResponse, "correctAnswerMarks": testSet[0].questionSet[i].correctAnswerMarks, "incorrectAnswerMarks": testSet[0].questionSet[i].incorrectAnswerMarks, "notAnswerMarks": testSet[0].questionSet[i].notAnswerMarks, "help": testSet[0].questionSet[i].help };
				if (testSet[0].questionSet[i].noQuestionAttempt && testSet[0].questionSet[i].noQuestionAttempt > 0) {
					item["noQuestionAttempt"] = testSet[0].questionSet[i].noQuestionAttempt;
				// }else if (testSet[0].noQuestionAttempt && testSet[0].noQuestionAttempt > 0) {
				// 	item["noQuestionAttempt"] = testSet[0].noQuestionAttempt;
				} else {
					item["noQuestionAttempt"] = 0;
				}
				ansQuestionSet.push(item);
			}
		}

		let testMode="";
		if(assessmentMode && assessmentMode==='beginner'){
			testMode="Learning Session";
		}else if(assessmentMode && assessmentMode==='advance'){
			testMode="Competitive Session";
		}

		// alert("courseId: "+cid+", templateId: "+tid);

		if (tid) {
			var postData = {
				"courseId": cid,
				"templateId": tid,
				"packTypeId": 1,
				"packTypeTitle": 'FREE',
				"testId": testSet[0].testId,
				"modelTestId": testSet[0].modelTestId, 
				"testType": testSet[0].testType,
				"testOption": testSet[0].testOption,
				"testMode": testMode,
				"totalTime": testSet[0].totalTime,
				"remainingTime": testSet[0].remainingTime,
				"totalQuestion": totalTestQuestions,
				"testTitle": testSet[0].testName,
				"questionSet": ansQuestionSet
			};
			if (testSet[0].noQuestionAttempt && testSet[0].noQuestionAttempt > 0) {
				postData["noQuestionAttempt"] = testSet[0].noQuestionAttempt;
			} else {
				postData["noQuestionAttempt"] = 0;
			}
			// if (etlStudentObj && etlStudentObj.schools && etlStudentObj.schools.length > 0) {
			// 	if (etlStudentObj.schools[0] && etlStudentObj.schools[0].admissionNumber && etlStudentObj.schools[0].admissionNumber.length > 0) {
			// 		postData["admissionNumber"] = etlStudentObj.schools[0].admissionNumber;
			// 	}
			// 	if (etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId && etlStudentObj.schools[0].schoolId > 0) {
			// 		postData["schoolId"] = etlStudentObj.schools[0].schoolId;
			// 	}
			// 	if (etlStudentObj.schools[0].schoolName != null && etlStudentObj.schools[0].schoolName.length > 0) {
			// 		postData["schoolName"] = etlStudentObj.schools[0].schoolName;
			// 	}
			// 	if (etlStudentObj.schools[0].className != null && etlStudentObj.schools[0].className.length > 0) {
			// 		postData["className"] = etlStudentObj.schools[0].className;
			// 	}
			// }
			if (testSet && testSet[0] && testSet[0].scheduleId && testSet[0].scheduleId.length > 0) {
				postData["scheduleId"] = testSet[0].scheduleId;
			}
			if (testSet && testSet[0] && testSet[0].subject && testSet[0].subject.length > 0) {
				postData["subject"] = testSet[0].subject;
			}

			if (helpCountQuestions && helpCountQuestions.length > 0) {
				postData["helpCounter"] = helpCountQuestions.length;
			} else {
				postData["helpCounter"] = 0;
			}

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': loginId,
					'token': token,
					'device': 'web'
				}
			};
			// alert("  "+JSON.stringify(postData)); 

			const data = new FormData();
			data.append('ansdetails', JSON.stringify(postData));
			data.append('source', 'guest');
			data.append('courseId', cid);
			data.append('testId', testSet[0].testId);
			data.append('testType', testSet[0].testType);
			axios.post(API_URL + '/testsubmit', data, axiosHeader)
				.then((response) => {
					//console.log("RESPONSE RECEIVED: ", response);
					if (response.data.responseTxt === "success") {
						//alert(JSON.stringify(response.data));
						if (examType === 'subjective') {
							if (response.data.obj.testType == 3 || response.data.obj.testType == 5) {
								window.location.href = "testviewsubjective?testId=mt" + response.data.obj.testSession;
							} else {
								window.location.href = "testviewsubjective?testId=st" + response.data.obj.testSession;
							}
						} else {
							if (response.data.obj.testType == 3 || response.data.obj.testType == 5) {
								//window.location.href = "profile";
								//alert('Thanks for Testing');
								window.location.href = "analytics?testId=" + response.data.obj.testSession;
							} else {
								if(response.data.obj.testType == 1 && response.data.obj.testMode=="Learning Session"){ //Learning Session
									window.location.href = "learning-testanalytics?testId=" + response.data.obj.testSession;
								}else{
									window.location.href = "testanalytics?testId=" + response.data.obj.testSession;
								}	
							}
						}
					}else if (response.data.responseTxt === "attempted-test") {
						regAlertRef.current.handleClickOpen();

					} else {
						setShowAlert(true);
						setAlertMessage("Your test could not be submitted successfully.");
						return false;
					}
				})
				.catch((error) => {
					setShowAlert(true);
					setAlertMessage("ERROR: ", error);
				})
		}
	}

	React.useEffect(() => {
		if (testType && testType>-1) {
			getApiData();
		}
	}, [testType]);

	async function getApiData() {
		
		let params = '';
		if(testType && testType>0){
			params = '?testType='+testType;
		}else{
			params = '?testType=0';
		}
		
		if (corsId && corsId > 0) {
			params += '&courseId=' + corsId;
		}

		if (courseUrl && courseUrl.length > 0) {
			params += '&courseUrl=' + courseUrl;
		}

		if (testUid && testUid != null) {
			params += '&testUid=' + testUid;
		}else{
			params += '&testUid=learning';
		}
		if (searchFlag && searchFlag.length > 0) {
			params += '&searchFlag=' + searchFlag;
		}
		if (searchQuery && searchQuery.length > 0) {
			params += '&searchQuery=' + searchQuery;
		}
		if (topicId && topicId > 0) {
			params += '&topicId=' + topicId;
		}

		// if (questionType && questionType != null) {
		// 	params += '&questionType=' + questionType;
		// }
		// if (totalTestQuestions && totalTestQuestions != null) {
		// 	params += '&totalQuestion=' + totalTestQuestions;
		// }
		// if (totalTime && totalTime != null) {
		// 	params += '&totalTime=' + totalTime;
		// }
		// if (marksCorrectAnswer && marksCorrectAnswer != null) {
		// 	params += '&marksCorrectAnswer=' + marksCorrectAnswer;
		// }
		// if (marksIncorrectAnswer && marksIncorrectAnswer != null) {
		// 	params += '&marksIncorrectAnswer=' + marksIncorrectAnswer;
		// }
		// if (marksNotAttempted && marksNotAttempted != null) {
		// 	params += '&marksNotAttempted=' + marksNotAttempted;
		// }
		// if (exammTyp && exammTyp.length > 0) {
		// 	params += '&examType=' + exammTyp;
		// } else if (examType && examType.length > 0) {
		// 	params += '&examType=' + examType;
		// }
		// params += '&packTypeTitle=' + mySelectedCourses[selectedCourse].packTypeTitle;

		let axiosHeader = {
			headers: {
				'Content-Type': 'multipart/mixed',
			}
		};

		setPageLoading(true);
		axios.get(API_URL + '/app/guest-testdetails' + params, axiosHeader)
			.then(response => {
				setPageLoading(false);
				//document.write(JSON.stringify(response.data));
				//console.log(JSON.stringify(response.data)); 
				if (response && response.status === 200 && response.data && response.data.responseTxt === 'success') {
					///document.write(JSON.stringify(response.data.obj));
					setTestSet(response.data.obj.list);
					setCourseId(response.data.obj.courseId);
					setTemplateId(response.data.obj.templateId);
					
					const apiResponseData = response.data.obj.list;
					if (apiResponseData[0] && apiResponseData[0].questionSet) {
						setCurrentQuestion(apiResponseData[0].lastQuestionIndex);
						setCurrentQuestionObj(apiResponseData[0].questionSet[0]);
						if (apiResponseData[0].lastQuestionIndex > 0 && document.getElementById('questionBox' + apiResponseData[0].lastQuestionIndex)) {
							document.getElementById('questionBox' + apiResponseData[0].lastQuestionIndex).style.display = "";
						} else if (document.getElementById('questionBox' + currentQuestion)) {
							document.getElementById('questionBox' + currentQuestion).style.display = "";
						}
						setTotalQuestion(Object.keys(apiResponseData[0].questionSet).length);
						setClock(apiResponseData[0].sectionLock == "No_Lock" ? apiResponseData[0].remainingTime : apiResponseData[0].questionSet[0].sectionTime);
						resetTimerRef.current.resetTimer(1);
						if (document.getElementById('notVisitedTotalDivId')) {
							document.getElementById('notVisitedTotalDivId').innerHTML = Object.keys(apiResponseData[0].questionSet).length;
						}
						/*********** POPULATE STARTING ************************/
						let currentNotVisitedTotal = 0;
						let currentAnsweredReviewTotal = 0;
						let currentReviewTotal = 0;
						let currentNotAnsweredTotal = 0;
						let currentAnsweredTotal = 0;
						for (let i = 0; i < apiResponseData[0].questionSet.length; i++) {

							if (apiResponseData[0].questionSet[i].columns && apiResponseData[0].questionSet[i].questionType.toLowerCase() == 'mr-matching-type') {
								let counterA = 0;
								for (let j = 0; j < apiResponseData[0].questionSet[i].columns[0].columnRows.length; j++) {
									for (let k = 0; k < apiResponseData[0].questionSet[i].columns[1].columnRows.length; k++) {
										if (apiResponseData[0].questionSet[i].studentResponse && apiResponseData[0].questionSet[i].studentResponse.indexOf(alphaArr[counterA]) > -1) {
											document.getElementById("ans" + apiResponseData[0].questionSet[i].questionId + "a" + (counterA + 1)).checked = true;
										}
										counterA++;
									}
								}
							} else if (apiResponseData[0].questionSet[i].questionType.toLowerCase().indexOf("subjective") > -1) {
								///alert("questionType: "+apiResponseData[0].questionSet[i].questionType);
								setExamType("subjective");
								if (apiResponseData[0].questionSet[i].studentResponse && apiResponseData[0].questionSet[i].studentResponse.length > 0) {
									let respoArr = apiResponseData[0].questionSet[i].studentResponse.split("$$$$$");
									document.getElementById("ans" + apiResponseData[0].questionSet[i].questionId + "a1").value = respoArr[0];
									document.getElementById("ans" + apiResponseData[0].questionSet[i].questionId + "a2").value = respoArr[1];
									document.getElementById("iframe" + apiResponseData[0].questionSet[i].questionId).src = respoArr[2];
									document.getElementById('remove' + apiResponseData[0].questionSet[i].questionId).style.display = '';
									document.getElementById('file' + apiResponseData[0].questionSet[i].questionId).style.display = 'none';
								}
							} else if (apiResponseData[0].questionSet[i].responseChoice && apiResponseData[0].questionSet[i].questionType.toLowerCase() == 'fill-in-blank') {
								document.getElementById("ans" + apiResponseData[0].questionSet[i].questionId + "a").value = apiResponseData[0].questionSet[i].studentResponse;

							} else if (apiResponseData[0].questionSet[i].responseChoice) {
								for (let j = 0; j < apiResponseData[0].questionSet[i].responseChoice.length; j++) {
									if (apiResponseData[0].questionSet[i].responseChoice[j] && apiResponseData[0].questionSet[i].responseChoice[j].responseId == apiResponseData[0].questionSet[i].studentResponse) {
										document.getElementById("ans" + apiResponseData[0].questionSet[i].questionId + "a" + j).checked = true;
									}
								}
							}

							let questionId = apiResponseData[0].questionSet[i].questionId;
							if (questionId && apiResponseData[0].questionSet[i].backgroundImg.indexOf('answered-review.png') > -1) {
								currentAnsweredReviewTotal++;
							} else if (questionId && apiResponseData[0].questionSet[i].backgroundImg.indexOf('review.png') > -1) {
								currentReviewTotal++;
							} else if (questionId && apiResponseData[0].questionSet[i].backgroundImg.indexOf('not-answered.png') > -1) {
								currentNotAnsweredTotal++;
							} else if (questionId && apiResponseData[0].questionSet[i].backgroundImg.indexOf('answered.png') > -1) {
								currentAnsweredTotal++;
							} else {
								currentNotVisitedTotal++;
							}

						}
						setNotVisitedTotal(currentNotVisitedTotal);
						setAnsweredTotal(currentAnsweredTotal);
						setNotAnsweredTotal(currentNotAnsweredTotal);
						setReviewTotal(currentReviewTotal);
						setAnsweredReviewTotal(currentAnsweredReviewTotal);
						/*********** POPULATE ENDING ************************/
					}
				} else if (response && response.data && response.data.responseTxt === "invalidToken") {
					window.location.href = 'logout';
				} else if (response && response.data) {
					setTextMessage(response.data.responseTxt);
				}

			}).catch((error) => {
				setTextMessage("" + error);
				//console.log("AXIOS ERROR: ", error);
			})
	}

	function setRemainingTime(testTime) {
		if (testTime) {
			testSet[0].remainingTime = testSet[0].remainingTime - 1;
			setSeconds(seconds => seconds + 1);
		}
	}

	function openTopNav(divid) {
		document.getElementById(divid).style.width = "250px";
		document.getElementById('timingBoxId').classList.add("testTimingBoxLeft");
		document.getElementById('timingBoxId').classList.remove("testTimingBox");
		document.getElementById('questionPanelId').classList.remove("questionPanelFull");
		document.getElementById('questionPanelId').classList.add("questionPanelShort");
	}

	function closeTopNav(divid) {
		document.getElementById(divid).style.width = "0";
		document.getElementById('timingBoxId').classList.remove("testTimingBoxLeft");
		document.getElementById('timingBoxId').classList.add("testTimingBox");
		document.getElementById('questionPanelId').classList.add("questionPanelFull");
		document.getElementById('questionPanelId').classList.remove("questionPanelShort");
	}

	function hideAlert() {
		setShowAlert(false);
	}

	function sectionDialogHide() {
		setSectionDialogShow(false);
	}

	/// start clock
	function startTimer() {
		resetTimerRef.current.resetTimer(2);
	}

	/// stop clock
	function stopTimer() {
		resetTimerRef.current.resetTimer(3);
	}

	function openHelp() {
		stopTimer();
		openHelpRef.current.handleClickOpen();
		if (currentQuestionObj && currentQuestionObj.questionId > 0) {
			if (helpCountQuestions.indexOf(currentQuestionObj.questionId) === -1) {
				helpCountQuestions.push(currentQuestionObj.questionId);
				setHelpCountQuestions(helpCountQuestions);
				currentQuestionObj.help=1;
			}
		}
	}



	/* RIGHT CLICK DISABLED ON THIS COMPONENT */
	document.addEventListener("contextmenu", (event) => {
		event.preventDefault();
	});

	/* CTRL KEY DISABLED ON THIS COMPONENT */
	document.addEventListener("keydown", function (event) {
		if (event.ctrlKey) {
			event.preventDefault();
		} else if (event.keyCode == 123) { // Prevent F12
			event.preventDefault();
		} else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
			event.preventDefault();
		}
	});

	/* REFRESH PAGE DISABLED ON THIS COMPONENT */
	if (window.performance) {
		if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
			document.addEventListener("keydown", function (event) {
				if ((event.which || event.keyCode) == 116 || (event.which || event.keyCode) == 17 || (event.which || event.keyCode) == 16 || (event.which || event.keyCode) == 82) {
					// Pressing F5 or Ctrl+R
					event.preventDefault();
				}
			});
		}

	}

	function onBodyClickAction() {
		if (window.screen.width < 480) {
			closeTopNav('mySidepanel');
		}
	}

	function uploadFile(qid) {

		if (qid) {
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
				}
			};
			const data = new FormData();
			var browseFile = document.querySelector('#file' + qid);
			if (browseFile && browseFile.files[0] && browseFile.files[0].name.length > 0) {
				data.append("uploadedFiles", browseFile.files[0]);
			}

			axios.post(API_URL + '/student-subjective-tempfile-upload', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					if (response && response.status === 200 && response.data.responseTxt === "success") {
						//alert("fileName: "+response.data.obj.virtualUrlFile);
						document.getElementById('file' + qid).value = '';
						document.getElementById('remove' + qid).style.display = '';
						document.getElementById('file' + qid).style.display = 'none';
						document.getElementById('ans' + qid + 'a2').value = response.data.obj.fileName;
						document.getElementById('iframe' + qid).src = response.data.obj.virtualUrlFile;
						return false;

					} else {
						setShowAlert(true);
						setAlertMessage("Your file could not be uploaded.");
						return false;
					}
				}).catch((error) => {
					setShowAlert(true);
					setAlertMessage("" + error);
					return false;
				})
		}

	}

	function removeFile(qid) {

		let fileTxt = document.getElementById('ans' + qid + 'a2');
		let fileNameTxt = '';
		if (fileTxt && fileTxt.value.length > 0) {
			fileNameTxt = fileTxt.value;
		}

		if (qid && fileNameTxt) {
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
				}
			};
			const data = new FormData();
			data.append("fileName", fileNameTxt);

			axios.post(API_URL + '/student-subjective-tempfile-remove', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
					if (response && response.status === 200 && response.data.responseTxt === "success") {
						document.getElementById('remove' + qid).style.display = 'none';
						document.getElementById('file' + qid).style.display = '';
						document.getElementById('file' + qid).value = '';
						document.getElementById('ans' + qid + 'a2').value = '';
						document.getElementById('iframe' + qid).src = '';
						return false;

					} else {
						setShowAlert(true);
						setAlertMessage("Your file could not be removed.");
						return false;
					}
				}).catch((error) => {
					setShowAlert(true);
					setAlertMessage("" + error);
					return false;
				})
		}

	}

	function upgradeNow(){
		// if(mySelectedCourses && selectedCourse>-1){
		// 	window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
		// }
	}

	function backTo(url) {
		if(url==='PreviousPage'){
			window.history.back();
		}else{
			window.location.href=url;
		}
	}

	function reg(opt){
		if(opt===1){	
			regOneRef.current.handleClickOpen();
		}else if(opt===2){
			regTwoRef.current.handleClickOpen();
		}else if(opt===3){
			selectCourseRef.current.handleClickOpen();
		}
	}

	return (
		<div>
			<MetaTags>
				<title>Test</title>
				<meta name="description" content="Test" />
			</MetaTags>
			{!window.navigator.onLine ?
				<div className='netBar' >Alert: It seems, you are not connected to the internet.</div>
				: null}
			{textMessage ? 
			<><Header />
				<div style={{marginTop:70,marginLeft:15}}><Button variant="text" onClick={() => {backTo('PreviousPage')}} size="small" style={{backgroundColor:'transparent',textTransform:'none'}} >Back to Previous Page</Button></div>
				<div style={{ color: '#FF0000', fontWeight: 'bold', textAlign: 'center', marginTop: 100, fontSize: 16 }}>
					{textMessage}
				</div>
				{(textMessage && (textMessage.indexOf("limit")>-1 || textMessage.indexOf("validity")>-1))?<>
					<div style={{ color: '#0000FF', fontWeight: 'bold', marginTop: -5, marginBottom: 5, textAlign: 'center', fontSize: 16 }} >Upgrade your Account to Give More {(assessmentMode && assessmentMode==='beginner')?<>Session</>:<>Test</>} </div>
					<div style={{textAlign: 'center'}}><Button title="Upgrade Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Upgrade Now</Button></div>
				</>:(textMessage && textMessage.indexOf("No question available")>-1)?<>
					<div style={{textAlign: 'center'}}><Button title="Back to Smart Learning" variant="contained" onClick={() => {backTo('selfassessor')}} size="small" color="primary" style={{textTransform:'none'}} >Go to Smart Learning</Button></div>
				</>:null}
			</>: null}
			<Box style={{ marginBottom: 100, marginLeft: 20, marginRight: 20 }}>
				{(pageLoading && !textMessage) ? <>
					{/* <LinearProgress />  */}
					{/* {(assessmentMode && assessmentMode==='beginner')?<>Simulating your learning session with AI. Please  wait</>:(assessmentMode && assessmentMode==='advance')?<>Simulating your assessment with with AI. Please  wait</>:<>Wait..., ETL is creating your test. Please do not refresh page.</>}</> */}
					{/* {(assessmentMode && assessmentMode.length>0)?<>ETL is creating your session using randomization. Please wait</>:<>Wait..., ETL is creating your test. Please do not refresh page.</>} */}
					</>: null}
				{(testSet != null && testSet[0] && testSet[0].questionSet) ? <>
					<Stack spacing={2} sx={{ width: '100%' }}>
						<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{ vertical, horizontal }}  >
							<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
								{alertMessage}
							</Alert>
						</Snackbar>
					</Stack>

					<Dialog
						open={sectionDialogShow}
						onClose={sectionDialogHide}
						aria-labelledby="alert-dialog-section-title"
						aria-describedby="alert-dialog-section-description"
					>
						<DialogTitle id="alert-dialog-section-title">
							Alert
						</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-section-description">
								Are you sure, You want to move to next section.<br />
								You would not be able to move previous section after moving.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button variant="outlined" size="small" onClick={sectionDialogHide}>Don't Move</Button>
							<Button variant="contained" size="small" color="primary" onClick={agreeToJumpSection} autoFocus>Okay, Move</Button>
						</DialogActions>
					</Dialog>

					<Box mt={1} className="noselect" >
						<Grid container spacing={2}>
							<Grid item md={6} xs={12}>
								{testSet[0] ? <span className='test-name' >{testSet[0].testName} </span> : null}
								{(testSet[0] && (!assessmentMode || assessmentMode!=='beginner')) ?<span style={{marginLeft:5}}><DialogTestIns /></span> : null}
							</Grid>
							<Grid id="timingBoxId" item md={6} xs={12} className='testTimingBoxLeft' >
								{((assessmentMode && assessmentMode==='beginner'))?<TimerHidden ref={resetTimerRef} />:<>
								{clock ? <span className='testTiming' ><Timer endtime={clock} ref={resetTimerRef} toCallParentMethod={timeFinished} toCallParentSetRemainingTime={setRemainingTime} /></span> : null}
								</>}
							</Grid>
						</Grid>
					</Box>

					<Box id="questionPanelId" className="questionPanelShort" onClick={() => { onBodyClickAction() }} >
						{(testSet != null && testSet[0] != null && testSet[0].questionSet) ? (testSet[0].questionSet || []).map((myQuestion, myqnum) => (
							<Box key={'qes' + myqnum} className="noselect" id={'questionBox' + myqnum} style={{ display: 'none' }}  >
								<Grid container spacing={2} >
									{(testSet[0].testType == 1 && assessmentMode==='beginner') ?
									<Grid style={{fontWeight:'bold',color:'#303f9f'}} item md={12} xs={12} >
										<span style={{color:'red'}}>DO NOT GUESS.</span> Answer only if SURE.  Otherwise take <span style={{color:'green'}}>HELP</span> to answer or SKIP
									</Grid>
									:null}
									{/* <Grid item md={12} xs={12} >
										{myQuestion.sectionName ? <div className='taglabelblu mr5' >Section: {myQuestion.sectionName}</div> : null}
										<div className='taglabelblu mr5' >Question Type: {myQuestion.questionTypeLabel}</div>
										<div className='taglabelblu mr5' >Question Id: {myQuestion.questionDisplayId}</div>
										<span className='taglabelgreen mr5' >Correct: {myQuestion.correctAnswerMarks}</span>
										{(myQuestion.questionTypeLabel && myQuestion.questionTypeLabel.toLowerCase().indexOf("subjective") == -1) ? <>
											<span className='taglabelred mr5' >Incorrect: {myQuestion.incorrectAnswerMarks}</span>
											<span className='taglabelyellow' >Not Answer: {myQuestion.notAnswerMarks}</span>
										</> : null}
									</Grid> */}
									<Grid item md={12} xs={12} >
										<div className='taglabelblu mr5' >Question Type: {myQuestion.questionTypeLabel}</div>
									</Grid>
									<Grid item md={12} xs={12} className="questionBox" >
										{(myQuestion.commonDataDescription && myQuestion.commonDataDescription.length > 0) ? <p className="preWrap animate-zoom" >
											{
												<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.commonDataDescription.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
											}
										</p> : null}
										<p className="preWrap animate-zoom" >
											<span className="questionNum" >Question {myqnum + 1}: </span>
											{(myQuestion.questionBody && myQuestion.questionBody.length > 0) ? <span>
												{
													<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
												}
											</span> : null}
										</p>
										{
											myQuestion.columns ?
												<p className="animate-zoom">
													<table width="100%">
														<tr>
															{
																(myQuestion.columns || []).map((myRow, index) => (
																	<td className="btmbdrgry pdlft10">
																		{(myRow.columnHeader && myRow.columnHeader.length > 0) ? <h3>
																				<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.columnHeader.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																		</h3> : null}	
																	</td>
																))
															}
														</tr>
														<tr>
															{(myQuestion.columns || []).map((myCol, indexCol) => (
																<td><table width="100%">{
																	(myCol.columnRows || []).map((myRow, indexrrr) => (
																		<tr>
																			<td key={'crwq' + indexrrr + 'dd' + indexCol} className="btmbdrgry pdlft10 content-justify preWrap" >
																				{myRow.rowId}.&nbsp;
																				{(myRow.rowName && myRow.rowName.length > 0) ?
																					<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.rowName.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																					: null
																				}
																			</td>
																		</tr>
																	))
																}</table>
																</td>
															))}
														</tr>
													</table>
												</p>
												: null
										}
										<p className="answerBox animate-zoom" >
											{
												(myQuestion.questionType && myQuestion.questionType.indexOf("Subjective") > -1) ?
												    <Box >
														<Grid container  >
															<Grid item md={6} xs={12} >	
																<table style={{width:'99%'}}>
																	<tr>
																		<td  >
																			<textarea id={"ans" + myQuestion.questionId + "a1"} style={{width:'99%',minHeight:500 }} placeholder='Type your answer' ></textarea>
																		</td>
																	</tr>
																</table>	
															</Grid>
															<Grid item md={6} xs={12} >
																<table style={{width:'99%'}}>
																	<tr>
																		<td style={{textAlign: 'center', verticalAlign:'top'}} >
																			<input type="file" id={"file" + myQuestion.questionId} onChange={(event) => { uploadFile(myQuestion.questionId) }} />
																			<input type='hidden' id={"ans" + myQuestion.questionId + "a2"} />
																			<span id={"remove" + myQuestion.questionId} style={{ textAlign: 'center', fontSize: 20, color: '#FF0000', cursor: 'pointer', display: 'none' }} title='Remove' ><i onClick={() => { removeFile(myQuestion.questionId) }} className="fa fa-remove"></i></span><br/>
																			<iframe id={"iframe" + myQuestion.questionId} style={{width:'99%',minHeight:500 }} src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
																		</td>
																	</tr>
																</table>
															</Grid>
														</Grid>
													</Box>
													: myQuestion.questionType == 'Matching-Type' ?
														<table><span hidden>{counterMRMT = 0}</span>
															<tr><th className="mrmtcol" ></th>{(myQuestion.columns[1].columnRows || []).map((myRow, index) => (<th key={'mrmatch' + index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
															{(myQuestion.columns[0].columnRows || []).map((myRowLeft, indexLeft) => (
																<tr key={'trmmt' + indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{(myQuestion.columns[1].columnRows || []).map((myRowRight, indexRight) => (<td key={'mrmtchkb' + indexRight} className="mrmtcol" ><input type="radio" id={"ans" + myQuestion.questionId + "a" + (counterMCMT = counterMCMT + 1)} value={alphaArr[counterMRMT - 1]} name={"ans" + myQuestion.questionId + 'tr' + indexLeft} className="inputRadio" /></td>))}</tr>
															))}
														</table>
														: myQuestion.questionType == 'MR-Matching-Type' ?
															<table><span hidden>{counterMRMT = 0}</span>
																<tr><th className="mrmtcol" ></th>{(myQuestion.columns[1].columnRows || []).map((myRow, index) => (<th key={'mrmatch' + index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
																{(myQuestion.columns[0].columnRows || []).map((myRowLeft, indexLeft) => (
																	<tr key={'trmmt' + indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{(myQuestion.columns[1].columnRows || []).map((myRowRight, indexRight) => (<td key={'mrmtchkb' + indexRight} className="mrmtcol" ><input type="checkbox" id={"ans" + myQuestion.questionId + "a" + (counterMRMT = counterMRMT + 1)} value={alphaArr[counterMRMT - 1]} className="inputRadio" /></td>))}</tr>
																))}
															</table>
															: myQuestion.questionType == 'Multiple-Response' ?
																(myQuestion.responseChoice || []).map((myRow, index) => (
																	<p key={'qkey' + myqnum + index} id={'qmrid' + myqnum + index} >
																		<span className="inputSpan" ><input type="checkbox" id={"ans" + myQuestion.questionId + "a" + index} value={myRow.responseId} className="inputRadio" /></span>
																		<span className="inputLable" style={{ marginRight: 10, fontWeight: 'normal' }}>{alphaArr[index]}.</span>
																		<span className="inputLable content-justify preWrap" >
																			<label for={"ans" + myQuestion.questionId + "a" + index} >
																				{(myRow.responseText && myRow.responseText.length > 0) ?
																					<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																					: null
																				}
																			</label>
																		</span>
																	</p>
																))
																: myQuestion.questionType == 'Integer-Type' ?
																	<table><tr>{
																		(myQuestion.responseChoice || []).map((myRow, index) => (
																			<td key={'atdit' + index} >
																				<span className="inputSpan" ><input value={myRow.responseId} type="radio" id={"ans" + myQuestion.questionId + "a" + index} onClick={() => { uncheckHandle("ans" + myQuestion.questionId + "a" + index) }} name={"ans" + myQuestion.questionId} className="inputRadio" /></span>
																				<span className="inputLableIT"><label for={"ans" + myQuestion.questionId + "a" + index} >{myRow.responseText}</label></span>
																				<input type="hidden" id={"hidetxtans" + myQuestion.questionId + "a" + index} />
																			</td>
																		))}
																	</tr></table>
																	: (myQuestion.questionType == 'Fill-In-Blank' || myQuestion.questionType == 'Fill-in-Blank') ?
																		<table><tr>
																			<td><input type="text" id={"ans" + myQuestion.questionId + "a"} onBlur={() => { mrResponse(currentQuestion) }} placeholder="Enter your answer" autoComplete='off' /></td>
																		</tr></table>
																		: (myQuestion.responseChoice || []).map((myRow, index) => (
																			<p key={'qkey' + myqnum + index} id={'qmrid' + myqnum + index}  >
																				<span className="inputSpan" ><input value={myRow.responseId} type="radio" id={"ans" + myQuestion.questionId + "a" + index} onClick={() => { uncheckHandle("ans" + myQuestion.questionId + "a" + index) }} name={"ans" + myQuestion.questionId} className="inputRadio" /></span>
																				<span className="inputLable" style={{ marginRight: 10, fontWeight: 'normal' }}>{alphaArr[index]}.</span>
																				<span className="inputLable content-justify preWrap" >
																					<label for={"ans" + myQuestion.questionId + "a" + index} >
																						{(myRow.responseText && myRow.responseText.length > 0) ?
																							<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																							: null
																						}
																					</label>
																				</span>
																				<input type="hidden" id={"hidetxtans" + myQuestion.questionId + "a" + index} />
																			</p>
																		))
											}
										</p>
									</Grid>
								</Grid>
							</Box>
						)) : null}
					</Box>


					{/* Side panel starting */}
					{testSet[0] ? <>
						<div className="sidepanelOpen">
							<Button className="openbtn" onClick={() => { openTopNav('mySidepanel') }} ><i className="fa fa-chevron-left"></i></Button>
						</div>
						<div id="mySidepanel" className="sidepanel">
							<Button className="closebtn" onClick={() => { closeTopNav('mySidepanel') }} ><i className="fa fa-chevron-right"></i></Button>

							<Box className="noselect qnumBox" >
								<Grid container spacing={2}>
									<Grid item md={12} xs={12}  >
										{(testSet[0] && testSet[0].sectionSet) ? (testSet[0].sectionSet || []).map((myQus, secIndex) => (
											<>
												{myQus.sectionName ? <div key={'secnm' + secIndex} className="sectionq clrboth">{myQus.sectionName}</div> : null}
												{(myQus.questionNumbers || []).map((myQN, numIndex) => (
													<>{/*testSet[0].questionSet[myQN.questionIndex].studentResponse*/}
														<span key={'ansnm' + numIndex} id={'ans' + myQN.questionId} hidden ></span>
														<Button key={'secbtn' + numIndex} id={'btn' + myQN.questionId} className={testSet[0].questionSet[myQN.questionIndex].cssName} style={{ background: testSet[0].questionSet[myQN.questionIndex].backgroundImg }} onClick={() => { jumpToQuestion(parseInt(myQN.questionIndex)) }} title={'Go to question: ' + (parseInt(myQN.questionIndex) + 1)} >{parseInt(myQN.questionIndex) + 1}</Button>
													</>
												))}
											</>
										)) : null}
									</Grid>
								</Grid>
							</Box>
							<Box className='bottomBoxFixed' >
								<Grid item md={6} xs={12} className="noselect" >

									<div className="qbg-mr"><div className="qbg-not-visited" style={{ background: "url('" + process.env.PUBLIC_URL + "/not-visited.png')" }} id="notVisitedTotalDivId" >{notVisitedTotal}</div> Not Visited</div>
									<div className="qbg-mr" style={{ marginLeft: '-1px' }}><div className="qbg-visited" style={{ background: "url('" + process.env.PUBLIC_URL + "/not-answered.png')" }} id="notAnsweredTotalDivId" >{notAnsweredTotal}</div> Not Answered</div>
									<div className="qbg-mr clrboth"><div className="qbg-visited" style={{ background: "url('" + process.env.PUBLIC_URL + "/answered.png')" }} id="answeredTotalDivId" >{answeredTotal}</div> Answered</div>
									<div className="qbg-mr "><div className="qbg-visited" style={{ background: "url('" + process.env.PUBLIC_URL + "/review.png')" }} id="reviewTotalDivId" >{reviewTotal}</div> Review</div>
									<div className="qbg-mr clrboth"><div className="qbg-visited" style={{ background: "url('" + process.env.PUBLIC_URL + "/answered-review.png')" }} id="answeredReviewTotalDivId" >{answeredReviewTotal}</div> Answered & Review</div>

								</Grid>
							</Box>
						</div>
					</> : null}
					{/* Side panel ending */}

				</> : null}


			</Box>

			{(testSet[0] && testSet[0] != null && testSet[0].questionSet) ?
				<Box className='bottomBoxFixedA' >
					<Grid container >
						<Grid item md={12} xs={12} className="textButtonBox" >
							<Button title="Previous" variant="contained" onClick={currentQuestion > 0 ? () => { backHandle() }:()=>{}} color={currentQuestion > 0 ?"primary":"inherit"} >Back</Button>
							{(testSet[0].testType == 1 && assessmentMode==='beginner') ? <Button title="Help" variant="contained" onClick={() => { openHelp() }} style={{backgroundColor:'green',color:'white'}} >Help</Button> : null}
							<Button title="Clear" variant="contained" onClick={() => { resetHandle() }} color="primary" >Clear</Button>
							<Button id="markforreviewButtonId" title="Mark for review" variant="contained" onClick={() => { markReview() }} color="primary" >Mark for Review</Button>
							<Button id="unmarkforreviewButtonId" style={{ display: 'none' }} title="Unmark for review" variant="contained" onClick={() => { unmarkReview() }} color="primary" >Unmark for Review</Button>

							<Button title="Save & Next" variant="contained" onClick={() => { nextHandle() }} color="primary" >Next</Button>
							
							<Button title={"Submit"} onClick={()=>{reg(1)}} variant="contained" color="primary" >Submit {testType==1?<>Session</>:<>Test</>} Now</Button>
							
							{/* <DialogSubmitTest testType={testType} toCallParentMethod={submitTest} toCallParentStopTestNow={stopTestNow} /> */}
							
						</Grid>
					</Grid>

					{(testSet[0].testType == 1) ?
						<DialogHelp toCallStartTimer={startTimer} ref={openHelpRef} currentQuestionObj={currentQuestionObj} searchFlag={searchFlag} searchQuery={searchQuery} topicId={topicId} />
						: null}

				</Box>
				: null}

			<AlertNoInternet ref={internetRef} />			
			<DialogRegOne ref={regOneRef} reg={reg} />
			<DialogRegTwo submitTest={submitTest} dataObj={{'courseId':courseId?courseId:0,'templateId':templateId?templateId:0,'utmSource':utmSource?utmSource:''}} ref={regTwoRef} reg={reg} /> 
			<DialogRegSelectCourse submitTest={submitTestWithCourse} topicId={topicId} ref={selectCourseRef} />
			<DialogRegAlert courseId={courseId} ref={regAlertRef}  />

				<Backdrop
					sx={{ flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={(pageLoading && !textMessage)}
					// onClick={handleClose}
				>
					<Box>
						<Grid container >
							<Grid item md={12}>
								<CircularProgress color="inherit" />
							</Grid>
						</Grid>
					</Box>
					<Box>
						<Grid container >
							<Grid item md={12}>
								{(assessmentMode && assessmentMode.length>0)?
								<>ETL is creating your session using randomization. Please wait</>
								:<>Wait..., ETL is creating your test. Please do not refresh page.</>}
							</Grid>
						</Grid>
					</Box>
				</Backdrop>

		</div>
	);

}




